import React from 'react'
import { useQueries } from '@tanstack/react-query'
import { userQueries } from '../../../../../../api/users'
import { getUserFullName } from '../../../../../../helpers/user'

interface AdminListModalContentProps {
  adminList?: string[]
}

export const AdminListModalContent = ({
  adminList,
}: AdminListModalContentProps): React.ReactNode => {
  const usersQuery = useQueries({
    queries: adminList?.map((adminId) => userQueries.getUser(adminId)) || [],
  })
  const admins = usersQuery.flatMap((query) => query.data || [])

  return (
    <div className="flex h-full flex-col gap-6">
      {admins?.map((admin) => (
        <div key={admin?._id} className="flex gap-4">
          <p className="w-60">{getUserFullName(admin)}</p>
          <p>{admin?._id}</p>
        </div>
      ))}
    </div>
  )
}
